<button class="boton_volver mb-4" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER">
  <i class="bi bi-chevron-left mr-2"></i>
  Volver
</button>

<h1 class="ocultar-desktop">Registro de calificaciones</h1>

<div class="py-2 my-5 borde_inferior_datos_secciones borde_superior_datos_secciones ocultar-desktop">

  <p class="mb-1 mt-3 text-uppercase">asignatura?.asignatura</p>
  <p class="mb-1 text-uppercase">asignatura?.periodo</p>
  <p class="mb-1 text-uppercase">docente.docente</p>
  <p class="mb-3 text-uppercase">asignatura?.sede</p>
</div>

<p class="text-center text-uppercase">Configuración de ponderaciones</p>

<!-- Calificaciones parciales -->
<div class="borde_inferior_datos_secciones fondo_gris ocultar-desktop">
  <div class="row">
      <div class="col-9 col-sm-10 col-md-10 col-lg-11">
          <p class="mb-0 mx-5 pt-3 datos_alumnos-suspensivo">
            <strong class="text-uppercase">Calificaciones Parciales</strong>
          </p>
      </div>
      <div class="col">
          <button class="btn"  data-toggle="collapse" [attr.data-target]="'#collapseParcial-1'" aria-expanded="false" aria-controls="collapseParcial">
            <i class="bi bi-plus-circle tamanio_iconos-boton ml-3"></i>
          </button>
      </div>
  </div>

  <div class="collapse ocultar-desktop" [id]="'collapseParcial-1'">
    <!-- borde_inferior_datos_secciones -->
    <div class="mt-4 mx-4 ocultar-desktop">
      <div class="row">
        
      </div>
    </div>
    
  </div>
</div>

<!-- Calificaciones examenes -->
<div class="borde_inferior_datos_secciones fondo_gris ocultar-desktop">
  <div class="row">
      <div class="col-9 col-sm-10 col-md-10 col-lg-11">
          <p class="mb-0 mx-5 pt-3 datos_alumnos-suspensivo">
            <strong class="text-uppercase">Calificación Examen</strong>
          </p>
      </div>
      <div class="col">
          <button class="btn"  data-toggle="collapse" [attr.data-target]="'#collapseExamen-1'" aria-expanded="false" aria-controls="collapseExamen">
            <i class="bi bi-plus-circle tamanio_iconos-boton ml-3"></i>
          </button>
      </div>
  </div>

  <div class="collapse ocultar-desktop" [id]="'collapseExamen-1'">
    <!-- borde_inferior_datos_secciones -->
    <div class="mt-4 mx-4 ocultar-desktop">
      <div class="row">
        <div class="col text-center">
          <button class="boton-secundario text-center w-75 mb-2">
            CP1 (10%)
          </button>

          <button class="boton-secundario text-center w-75 mb-2">
            CP1 (10%)
          </button>
        </div>
      </div>
    </div>
    
  </div>
</div>